import apiClient from './apiClient';

export interface F93D {
  f93d_01: string;  // 員工代號
  f93d_11: string;  // 員工姓名
  f93d_12: string;  // 起始年月
  f93d_13: string;  // 結束年月
  f93d_31: number;  // 本薪
  f93d_32: number;  // 伙食津貼
  f93d_33: number;  // 加班費
  f93d_36: number;  // 代扣稅額
  f93d_37: number;  // 勞保費
  f93d_38: number;  // 健保費
  f93d_39: number;  // 退休金
  f93d_91: string;
  f93d_92: string | null;
  f93d_93: string;
}

export interface CreateRequest {
  f93d_01: string; f93d_11: string; f93d_12: string; f93d_13: string;
  f93d_31: number; f93d_32: number; f93d_33: number;
  f93d_36: number; f93d_37: number; f93d_38: number; f93d_39: number;
}

export interface UpdateRequest {
  f93d_11: string; f93d_12: string; f93d_13: string;
  f93d_31: number; f93d_32: number; f93d_33: number;
  f93d_36: number; f93d_37: number; f93d_38: number; f93d_39: number;
}

export interface ListResponse { data: F93D[]; total: number; page: number; size: number; }

export const casualPayrollApi = {
  async list(page = 1, size = 500, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    return (await apiClient.get('/api/casual-payroll', { params })).data;
  },
  async get(code: string): Promise<F93D> {
    return (await apiClient.get(`/api/casual-payroll/${encodeURIComponent(code)}`)).data;
  },
  async create(data: CreateRequest): Promise<F93D> {
    return (await apiClient.post('/api/casual-payroll', data)).data;
  },
  async update(code: string, data: UpdateRequest): Promise<F93D> {
    return (await apiClient.put(`/api/casual-payroll/${encodeURIComponent(code)}`, data)).data;
  },
  async delete(code: string): Promise<void> {
    await apiClient.delete(`/api/casual-payroll/${encodeURIComponent(code)}`);
  },
};
